import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../reducers';
import { HTTPMethods } from '../../../yoello-lib/modules/API/API';
import APIExtensions from '../../../yoello-lib/modules/API2/APIDefs';
import { useAPIV2 } from '../../../yoello-lib/modules/API2/useAPIv2';
import { useSnackbarMessages } from '../../../yoello-lib/modules/components/snackbar/SnackbarContext';

declare type DeliveryFeeType = {
  venue_id: string,
  amount: number,
  distance_from: number,
  distance_unit: string,
  id?:string
}

export function useDeliveryFees() {
  const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const {t} = useTranslation();
  const {sendSnackbarMessage} = useSnackbarMessages()!;
  const { apiData: deliveryFees, callAPI: callDeliveryFees, isLoading } = useAPIV2<DeliveryFeeType[]>(APIExtensions.delivery_fees, {
    params:{
      venue_id:selectedVenueId
    }
  });
  const [deliveryFeesState, setdeliveryFeesState] = useState([]);

  useEffect(() => {
    // @ts-ignore
    setdeliveryFeesState(deliveryFees ?? [])
  }, [deliveryFees])
  

  function checkDuplicate(data:DeliveryFeeType[]) {
    const distances = data.map(item=> Number(item.distance_from));
    const toFindDuplicates = (array:number[]) => array.filter((item, index) => array.indexOf(item) !== index)
    const duplicateElements = toFindDuplicates(distances);
    return duplicateElements;
  }

  async function onDeliveryFeesSubmit(data:DeliveryFeeType[]){
    const hasDuplicate = checkDuplicate(data);
    // @ts-ignore
    setdeliveryFeesState(data)
    if(hasDuplicate.length > 0){
      sendSnackbarMessage(t("forms.orders.duplicateDistanceSnackbar"),"error");
      return true;
    }
    const payload = data.map((item:any)=>{
      return {
          "venue_id": selectedVenueId,
          "amount": item.amount,
          "distance_from": Number(item.distance_from),
          "distance_unit": "KILOMETER"
      }
    })
      await callDeliveryFees(HTTPMethods.POST,{
        body:{
          delivery_fees:payload
        },
        params:{
          venue_id:selectedVenueId
        }
      }).finally(()=>{
        sendSnackbarMessage(t("snackbar.updateSuccess"),"success");
      })
      
      return true
  }
  
return {
    onDeliveryFeesSubmit,
    deliveryFees: deliveryFeesState,
    isLoading
}
}
